import React, { useState, useEffect } from "react"

const LandingPageSelection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 841)

  const FGHGameSelectionData = [
    {
      id: 1,
      Game_Type: "Sportsbook",
      Game_Type_Title: "Sportsbook",
      Game_Type_Label: "Ultimate",
      Game_Type_Desc: "Bet on your favorite teams and win big!",
      Game_Type_Img: "/images/sportsbook-selection-img.webp?v=1",
      Game_Type_Desktop: "/images/sportsbook-selection-desktop.webp?v=1",
      Game_Type_Link: "Bet Live Now",
      Game_Type_Button: "/sportsbook",
      Game_Type_Class: "sportsbook",
      Game_Type_TitleClass: "sportsbook",
    },
    {
      id: 2,
      Game_Type: "Fishing Games",
      Game_Type_Title: "Fishing",
      Game_Type_Label: "Start",
      Game_Type_Desc: "Cast your line catch massive rewards!",
      Game_Type_Img: "/images/fishing-selection-img.webp?v=1",
      Game_Type_Desktop: "/images/fishing-selection-desktop.webp?v=1",
      Game_Type_Link: "Shoot Now",
      Game_Type_Button: "/slots/?category=Fishing%20Games",
      Game_Type_Class: "fishing",
      Game_Type_TitleClass: "fishing",
    },
    {
      id: 3,
      Game_Type: "Bingo",
      Game_Type_Title: "Bingo",
      Game_Type_Label: "Lets Play",
      Game_Type_Desc: "Grab your numbers, shout BINGO!",
      Game_Type_Img: "/images/bingo-selection-img.webp?v=1",
      Game_Type_Desktop: "/images/bingo-selection-desktop.webp?v=1",
      Game_Type_Link: "Start Playing",
      Game_Type_Button: "/slots/?category=Bingo%20Games",
      Game_Type_Class: "bingo",
      Game_Type_TitleClass: "bingo",
    },
    {
      id: 4,
      Game_Type: "Arcade",
      Game_Type_Title: "Arcade",
      Game_Type_Label: "Enter The",
      Game_Type_Desc: "Play fun games, win exciting prizes!",
      Game_Type_Img: "/images/arcade-selection-img.webp?v=1",
      Game_Type_Desktop: "/images/arcade-selection-desktop.webp?v=1",
      Game_Type_Link: "Play To Win",
      Game_Type_Button: "/slots/?category=Arcade%20Games",
      Game_Type_Class: "arcade",
      Game_Type_TitleClass: "arcade",
    },
  ]

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <div className="fgh-game-selection-container">
      <div className="fgh-headlines-controls">
        <h2 className="fgh-h2-style">Unique Games You Must Try</h2>
      </div>

      <div className="fgh-game-selection-items">
        {FGHGameSelectionData.map((FGHSelection) => (
          <div key={FGHSelection.id} className="fgh-game-selection-item">
            <img
              src={
                isMobile
                  ? FGHSelection.Game_Type_Img
                  : FGHSelection.Game_Type_Desktop
              }
              alt={FGHSelection.Game_Type_Title}
              className="fgh-game-selection-bimg"
            />

            <div className="fgh-game-selection-details">
              <p className="fgh-game-selection-label">
                {FGHSelection.Game_Type_Label}
              </p>

              <h3
                className={`fgh-game-selection-title ${FGHSelection.Game_Type_TitleClass}`}
              >
                {FGHSelection.Game_Type_Title}
              </h3>

              <p className="fgh-game-selection-desc">
                {FGHSelection.Game_Type_Desc}
              </p>

              <a
                href={FGHSelection.Game_Type_Button}
                className={`fgh-game-selection-button fgh-normal-button ${FGHSelection.Game_Type_Class}`}
              >
                {FGHSelection.Game_Type_Link}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LandingPageSelection
